// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import { store } from './store/index.js'
import axios from 'axios'
import mixin from './mixins/helpers.js'
// import { axiosConfig } from './axios.config'
import { VueExtendLayout, layout } from 'vue-extend-layout'
import VeeValidate from 'vee-validate'
import VueCookies from 'vue-cookies'
import FullCalendar from 'vue-full-calendar'
import wysiwyg from 'vue-wysiwyg'

require('vue-multiselect/dist/vue-multiselect.min.css')
const config = {
  errorBagName: 'errors', // change if property conflicts.
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: null,
  strict: true
}

axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  if (router.currentRoute.path === '/login') {
    return Promise.reject(error)
  }

  if (error.response.status === 401) {
    VueCookies.remove('token')
    localStorage.removeItem('session_user_login_count')
    localStorage.removeItem('token')
    localStorage.removeItem('session_user')
    localStorage.removeItem('session_company')
    localStorage.removeItem('session_roles')
    localStorage.removeItem('session_permissions')
    router.push('/login')
  }
})

axios.defaults.headers.common['Authorization'] = 'Bearer ' + VueCookies.get('token')

Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.use(FullCalendar)
Vue.use(VueExtendLayout)
Vue.use(VeeValidate, config)
Vue.use(VueCookies)
Vue.use(wysiwyg, {})
Vue.mixin(mixin)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  ...layout
})



// WEBPACK FOOTER //
// ./src/main.js